<template>
  <v-main class="main">
    <AppNavigation />
    <v-layout>
      <slot />
    </v-layout>
    <div class="mb-6"></div>
  </v-main>
</template>

<script>
import AppNavigation from '@/components/AppNavigation'

export default {
  name: 'Main',
  components: {
    AppNavigation,
  },
}
</script>

<style lang="scss">
.main {
  background: #e4e4e7;
}
</style>
